import { ServerRuntimeMetaArgs } from "@remix-run/server-runtime/dist/routeModules";

export const iconMeta = (matches: ServerRuntimeMetaArgs["matches"]) =>
  matches
    .find((x) => x.id === "root")
    ?.meta?.find((x: any) => x.tagName === "link" && x.rel === "icon") ?? {
    tagName: "link",
    rel: "icon",
    href: "/favicon.ico",
  };
